<template>
    <window :title="title">
        <table class="table table-bordered">
            <thead style="background: #ffccff">
                <tr>
                    <th>項目</th>
                    <th>学習状況</th>
                    <th>最終学習日時</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <router-link :to="`/intro/${contentsName}`"
                            >基礎知識編</router-link
                        >
                    </td>
                    <td>
                        {{
                            statusData.base.isComplete
                                ? "〇"
                                : statusData.base.lastStudyTime != ""
                                ? "×"
                                : "―"
                        }}
                    </td>
                    <td>{{ statusData.base.lastStudyTime }}</td>
                </tr>
                <tr>
                    <td>
                        <router-link :to="`/story/${contentsName}`"
                            >ストーリー編</router-link
                        >
                    </td>
                    <td>
                        {{
                            statusData.story.isComplete
                                ? "〇"
                                : statusData.story.lastStudyTime != ""
                                ? "×"
                                : "―"
                        }}
                    </td>
                    <td>{{ statusData.story.lastStudyTime }}</td>
                </tr>
                <tr>
                    <td>
                        <router-link :to="`/test/${contentsName}`"
                            >テスト編</router-link
                        >
                    </td>
                    <td>
                        {{
                            statusData.test.isComplete
                                ? "〇"
                                : statusData.test.lastStudyTime != ""
                                ? "×"
                                : "―"
                        }}
                    </td>
                    <td>{{ statusData.test.lastStudyTime }}</td>
                </tr>
            </tbody>
        </table>
        〇：学習済み/合格，―：未学習，×：不合格
    </window>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "contents-menu",
    data() {
        return {
            title: "TOP",
        };
    },
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
            "getStatusIncident",
            "getStatusWeb",
            "getStatusInformation",
            "getStatusMail",
            "getStatusPassword",
        ]),
        contentsName() {
            return this.$route.params.contents;
        },
        statusData() {
            let status = null;
            if (this.contentsName == "mail") status = this.getStatusMail();
            else if (this.contentsName == "web") status = this.getStatusWeb();
            else if (this.contentsName == "information")
                status = this.getStatusInformation();
            else if (this.contentsName == "pswd")
                status = this.getStatusPassword();
            else if (this.contentsName == "incident")
                status = this.getStatusIncident();
            return status;
        },
    },
    methods: {},
};
</script>
